export default {
  apiUrl: '/api/suppliers',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'supplier-editor',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__slot:actions',
      title: '수정 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<i style="white-space: nowrap">아이디</i>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name',
      title: '<i style="white-space: nowrap">공급자</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'prepare_days',
      title: '<i style="white-space: nowrap">공급 준비 일자</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/supplier-management/Config.js